// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6W9RR {\n  display: block;\n  width: 670px\n}\n._6W9RR.bp3-card {\n    padding: 20px 35px;\n  }\n.fecnG {\n    font-weight: bold;\n    padding-top: 10px;\n  }\n.xWmSV {\n    display: flex;\n    justify-content: flex-end;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GenerateApiKeyCard": "_6W9RR",
	"GenerateApiKeyCard_generateApiLink": "fecnG",
	"GenerateApiKeyCard_generateButton": "xWmSV"
};
export default ___CSS_LOADER_EXPORT___;
